import { Component, Input, OnInit, OnDestroy, ViewContainerRef, ChangeDetectorRef } from '@angular/core';
import { MdDialog, MdDialogConfig, MdDialogRef } from '@angular/material';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';

import { Agreement } from 'app/entities/transaction-profile/agreement.model';
import { AddDocumentComponent } from 'app/entities/transaction-profile/documents/adddocument/add-document.component';
import { EntityTransactionProfileService } from 'app/entities/transaction-profile/entity-transaction-profile.service';
import { EntityDocumentsService } from 'app/entities/documents/entity-documents.service';
import { ConstantsService } from 'app/services/constants-service';
import { CookieService } from 'app/services/cookie.service';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { Document } from 'app/shared/models/document.model';
import { EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { ApplicationTypeConstants, WarmUpService } from 'app/services/warmup/warmup.service';
import { User } from 'app/shared/models/user.model';
import { Observable } from 'rxjs';

@Component({
    selector: 'documents',
    templateUrl: './document.component.html',
    styleUrls: ['./document.component.css']
})

export class DocumentComponent implements OnInit, OnDestroy {
    @Input() entityIdDetails: EntityIdDetails;
    documents: Document[] = [];
    dialogRef: MdDialogRef<any>;
    selectedDocument: Document;
    selectedAgreement: Agreement;
    documentsLoaded = false;
    zeroAggrement = true; // when there is no aggrement we will disable to add document.
    private subscriptions: Subscription[] = [];

    // Upload form properties
    uploadForm: FormGroup;
    selectedFiles: File[] = [];
    documentTypes: ApplicationValue[];
    documentLabels = [];
    selectedDocumentType: string;
    countries = [];
    users: User[];
    loginUser: string;
    isUploading = false;
    showUploadSection = false;
    dragOver = false;

    constructor(
        public dialog: MdDialog,
        public viewContainerRef: ViewContainerRef,
        private transactionProfileService: EntityTransactionProfileService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
        private formBuilder: FormBuilder,
        private entityDocumentsService: EntityDocumentsService,
        private warmUpService: WarmUpService,
        private cookieService: CookieService,
        private cdr: ChangeDetectorRef) { }

    ngOnInit() {
        console.log('DocumentComponent ngOnInit, entityIdDetails:', this.entityIdDetails);
        console.log('Current selectedAgreement at init:', this.selectedAgreement);
        this.setSelectedAgreementSubscriber();
        this.buildUploadForm();
        this.loadDocumentTypes();
        this.loadDocumentLabels();
        this.loadCountries();
        this.loginUser = this.cookieService.get(ConstantsService.COOKIE_LOGIN_USER_NAME);
        const usersList = this.warmUpService.getUsersList();
        // Convert to array if it's a Map or has values() method
        if (usersList instanceof Map) {
            this.users = Array.from(usersList.values());
        } else if (usersList && typeof usersList === 'object' && typeof usersList.values === 'function') {
            this.users = Array.from(usersList.values());
        } else if (Array.isArray(usersList)) {
            this.users = usersList;
        } else {
            this.users = [];
        }
        console.log('DocumentComponent initialized, subscription set up');
    }

    buildUploadForm() {
        this.uploadForm = this.formBuilder.group({
            documentType: ['', Validators.required],
            selectedLabels: [[]],
            documentDescription: [''],
            startDate: [''],
            endDate: [''],
            passportNumber: [''],
            validFrom: [''],
            validTo: [''],
            issuedBy: [''],
            verifiedBy: [''],
            certifiedBy: ['']
        });
    }

    loadDocumentTypes() {
        const documentTypeValues = this.warmUpService.getApplicationValue(ApplicationTypeConstants.DOCUMENT_TYPE);
        if (documentTypeValues instanceof Observable) {
            documentTypeValues.subscribe(
                response => {
                    this.warmUpService.setApplicationTypeInLS(response);
                    // Convert to array if it's a Map or has values() method
                    if (response.values instanceof Map) {
                        this.documentTypes = Array.from(response.values.values()) as ApplicationValue[];
                    } else if (response.values && typeof response.values === 'object' && typeof response.values.values === 'function') {
                        this.documentTypes = Array.from(response.values.values()) as ApplicationValue[];
                    } else if (Array.isArray(response.values)) {
                        this.documentTypes = response.values as ApplicationValue[];
                    } else {
                        this.documentTypes = [];
                    }
                }
            );
        } else if (documentTypeValues instanceof Object && documentTypeValues['values']) {
            const values = documentTypeValues['values'];
            // Convert to array if it's a Map or has values() method
            if (values instanceof Map) {
                this.documentTypes = Array.from(values.values()) as ApplicationValue[];
            } else if (values && typeof values === 'object' && typeof values.values === 'function') {
                this.documentTypes = Array.from(values.values()) as ApplicationValue[];
            } else if (Array.isArray(values)) {
                this.documentTypes = values as ApplicationValue[];
            } else {
                this.documentTypes = [];
            }
        } else {
            this.documentTypes = documentTypeValues || [];
        }
    }

    loadDocumentLabels() {
        this.entityDocumentsService.getDocumentLabels().subscribe(
            response => {
                let values = response.arrResult['values'];
                // Convert to array if it's a Map or has values() method
                if (values instanceof Map) {
                    values = Array.from(values.values());
                } else if (values && typeof values === 'object' && typeof values.values === 'function') {
                    values = Array.from(values.values());
                } else if (!Array.isArray(values)) {
                    values = [];
                }
                
                for (const labelObj of values) {
                    this.documentLabels.push({ 
                        label: labelObj.name, 
                        value: { id: labelObj.id, name: labelObj.name },
                        name: labelObj.name
                    });
                }
            }
        );
    }

    loadCountries() {
        const setCountries = (values) => { 
            // Convert to array if it's a Map or has values() method
            if (values instanceof Map) {
                this.countries = Array.from(values.values());
            } else if (values && typeof values === 'object' && typeof values.values === 'function') {
                this.countries = Array.from(values.values());
            } else if (Array.isArray(values)) {
                this.countries = values;
            } else {
                this.countries = [];
            }
        };
        this.warmUpService.getApplicationValueList(ApplicationTypeConstants.COUNTRY_TYPE, setCountries);
    }

    documentTypeChange(documentId: number) {
        const selectedDocument = this.documentTypes.find(doc => doc.id === documentId);
        if (selectedDocument) {
            this.selectedDocumentType = selectedDocument.name;
            // Reset form except document type
            const documentType = this.uploadForm.get('documentType').value;
            this.uploadForm.reset();
            this.uploadForm.patchValue({ documentType: documentType });
        }
        this.cdr.detectChanges();
    }

    toggleUploadSection() {
        this.showUploadSection = !this.showUploadSection;
        if (!this.showUploadSection) {
            this.selectedFiles = [];
            this.uploadForm.reset();
        }
    }

    onFileSelected(event: any) {
        const files = Array.from(event.target.files) as File[];
        this.addFiles(files);
    }

    addFiles(files: File[]) {
        files.forEach(file => {
            if (!this.selectedFiles.find(f => f.name === file.name && f.size === file.size)) {
                this.selectedFiles.push(file);
            }
        });
    }

    removeFile(index: number) {
        this.selectedFiles.splice(index, 1);
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = true;
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
        
        const files = event.dataTransfer && event.dataTransfer.files;
        if (files && files.length > 0) {
            this.addFiles(Array.from(files) as File[]);
        }
    }

    uploadDocuments() {
        if (this.uploadForm.invalid || this.selectedFiles.length === 0) {
            return;
        }

        this.isUploading = true;
        const formValue = this.uploadForm.value;
        
        // Create FileList-like object that works with the service
        const fileList = this.createFileList(this.selectedFiles);

        // Upload files
        const xhr = this.transactionProfileService.uploadDocumentForAgreement(
            fileList as any,
            this.entityIdDetails.entityId,
            this.selectedAgreement.id
        );

        xhr.onreadystatechange = () => {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    let response = false;
                    let documentIds = [];
                    if (xhr.response) {
                        const parsedResponse = JSON.parse(xhr.response);
                        response = parsedResponse.flagResult;
                        documentIds = parsedResponse.arrResult || [];
                        
                        if (documentIds.length > 0) {
                            this.updateDocumentData(documentIds, formValue);
                        } else if (response) {
                            this.snackBarService.showStatus(
                                parsedResponse,
                                MessageService.ADDED_DOCUMENT_SUCCESS,
                                MessageService.DOCUMENT_FAILURE
                            );
                            this.isUploading = false;
                            this.toggleUploadSection();
                            this.reloadDocuments();
                        } else {
                            this.snackBarService.showStatus(
                                parsedResponse,
                                '',
                                MessageService.DOCUMENT_FAILURE
                            );
                            this.isUploading = false;
                        }
                    }
                } else {
                    this.snackBarService.showStatus(
                        { flagResult: false },
                        '',
                        MessageService.DOCUMENT_FAILURE
                    );
                    this.isUploading = false;
                }
            }
        };
    }

    updateDocumentData(documentIds: number[], formValue: any) {
        const documents = this.createDocumentsForDocumentIds(documentIds, formValue);
        this.entityDocumentsService.addDocument(documents)
            .subscribe(
                response => {
                    this.snackBarService.showStatus(
                        response,
                        MessageService.ADDED_DOCUMENT_SUCCESS,
                        MessageService.DOCUMENT_FAILURE
                    );
                    this.isUploading = false;
                    this.toggleUploadSection();
                    this.reloadDocuments();
                },
                err => {
                    this.snackBarService.showStatus(
                        err,
                        '',
                        MessageService.DOCUMENT_FAILURE
                    );
                    this.isUploading = false;
                }
            );
    }

    createDocumentsForDocumentIds(documentIds: number[], formValue: any): Document[] {
        const documents = [];
        documentIds.forEach(documentId => {
            const document = new Document();
            document.dateOfUpload = new Date();
            document.entityId = this.entityIdDetails.entityId;
            document.validFrom = formValue.validFrom;
            document.validTo = formValue.validTo;
            document.type = formValue.documentType;
            document.docOwner = this.loginUser;
            
            if (formValue.selectedLabels && formValue.selectedLabels.length > 0) {
                for (const label of formValue.selectedLabels) {
                    document.labels.set(label.id, label.name);
                }
            }
            
            document.id = documentId;
            
            if (this.selectedDocumentType === 'Passport') {
                if (formValue.passportNumber) document.allMeta.set('passportNumber', String(formValue.passportNumber));
                if (formValue.issuedBy) document.allMeta.set('issuedBy', String(formValue.issuedBy));
                if (formValue.verifiedBy) document.allMeta.set('verifiedBy', String(formValue.verifiedBy));
                if (formValue.validFrom) document.allMeta.set('validFrom', String(formValue.validFrom));
                if (formValue.validTo) document.allMeta.set('validTo', String(formValue.validTo));
                if (formValue.certifiedBy) document.allMeta.set('certifiedBy', String(formValue.certifiedBy));
            } else if (this.selectedDocumentType === 'Indemnity Agreement' || 
                       this.selectedDocumentType === 'Service Agreement') {
                if (formValue.startDate) document.allMeta.set('startDate', String(formValue.startDate));
                if (formValue.endDate) document.allMeta.set('endDate', String(formValue.endDate));
            } else {
                if (formValue.documentDescription) document.allMeta.set('otherDetails', String(formValue.documentDescription));
            }
            
            documents.push(document);
        });
        return documents;
    }

    isUploadDisabled(): boolean {
        return this.uploadForm.invalid || this.selectedFiles.length === 0 || this.isUploading;
    }

    createFileList(files: File[]): FileList {
        // Create a FileList-like object that the service can use
        const fileList = {
            length: files.length,
            item: (index: number) => files[index] || null
        } as FileList;
        
        // Add array index access
        files.forEach((file, index) => {
            (fileList as any)[index] = file;
        });
        
        return fileList;
    }

    setSelectedAgreementSubscriber() {
        // Unsubscribe from previous subscription if it exists
        const existingSub = this.subscriptions.find(sub => sub && !sub.closed);
        if (existingSub) {
            existingSub.unsubscribe();
        }
        
        const subscription = this.transactionProfileService.selectedAgreement.subscribe(agreement => {
            console.log('DocumentComponent received agreement:', agreement);
            console.log('Current selectedAgreement before update:', this.selectedAgreement);
            if (agreement != null) {
                this.selectedAgreement = agreement;
                console.log('Selected agreement set to:', this.selectedAgreement);
                console.log('selectedAgreement.id:', this.selectedAgreement ? this.selectedAgreement.id : 'null');
                console.log('Card should be visible (hidden=false):', !(!this.selectedAgreement || !this.selectedAgreement.id));
                console.log('Loading documents for agreement:', agreement.id);
                this.loadDocuments();
                this.zeroAggrement = false;
                console.log('Triggering change detection...');
                // Use markForCheck to ensure change detection runs
                this.cdr.markForCheck();
                setTimeout(() => {
                    this.cdr.detectChanges();
                    console.log('Change detection after setTimeout');
                }, 0);
            } else {
                console.log('Agreement is null, clearing documents');
                this.selectedAgreement = null;
                this.documents = [];
                this.documentsLoaded = true;
                this.cdr.markForCheck();
                this.cdr.detectChanges();
            }
        });
        this.subscriptions.push(subscription);
    }

    loadDocuments() {
        console.log('loadDocuments called, selectedAgreement:', this.selectedAgreement);
        if (this.selectedAgreement && this.selectedAgreement.id) {
            this.documentsLoaded = false;
            const subscription = this.transactionProfileService.getDocumentsByAgreementId(this.selectedAgreement.id)
                .subscribe(response => {
                    console.log('Documents loaded:', response);
                    this.documents = response || [];
                    this.documentsLoaded = true;
                    this.zeroAggrement = false;
                    console.log('Documents array:', this.documents);
                    console.log('selectedAgreement:', this.selectedAgreement);
                    console.log('selectedAgreement.id:', this.selectedAgreement ? this.selectedAgreement.id : 'null');
                    console.log('Card should be visible (hidden=false):', !(!this.selectedAgreement || !this.selectedAgreement.id));
                    // Use markForCheck and detectChanges to ensure view updates
                    this.cdr.markForCheck();
                    setTimeout(() => {
                        this.cdr.detectChanges();
                        console.log('Change detection after timeout, selectedAgreement:', this.selectedAgreement);
                    }, 10);
                }, error => {
                    console.error('Error loading documents:', error);
                    this.documents = [];
                    this.documentsLoaded = true;
                    this.cdr.detectChanges();
                });
            this.subscriptions.push(subscription);
        } else {
            console.log('No agreement selected, setting documentsLoaded to true');
            this.documentsLoaded = true;
            this.cdr.detectChanges();
        }
    }


    downloadDocument(id: number) {
      window.open(ConstantsService.APP_BE_URL +'/'+ ConstantsService.DOWNLOAD_DOCUMENT + '?documentId=' + id);
    }

    removeDocument(document: Document): void {
        const transProfileDocumentModel = new Document();
        transProfileDocumentModel.id = document.id;
        const agreementId = this.selectedAgreement.id;
        const subscription = this.transactionProfileService.removeDocument(transProfileDocumentModel, agreementId)
            .subscribe(response => {
                if (response.flagResult) {
                    this.documents.splice(this.documents.indexOf(document), 1);
                }
                this.trackingService
                    .emitEvent(
                    TrackingConstants.TRANS_PROFILE_DOCUMENT,
                    TrackingConstants.DELETE_DOCUMENT,
                    TrackingConstants.SUCCESS, 1);
                this.callSnackBarServiceForDocumentRemoval(response);
            }, err => {
                this.trackingService
                    .emitEvent(
                    TrackingConstants.TRANS_PROFILE_DOCUMENT,
                    TrackingConstants.DELETE_DOCUMENT,
                    TrackingConstants.FAILURE, 0);
                this.callSnackBarServiceForDocumentRemoval(err);
            }
            );
        this.subscriptions.push(subscription);
    }


    reloadDocuments() {
        const subscription = this.transactionProfileService.getDocumentsByAgreementId(this.selectedAgreement.id).subscribe(
            response => {
                this.documents = response;
            }
        );
        this.subscriptions.push(subscription);
    }

    callSnackBarServiceForDocumentRemoval(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.DOCUMENT_DELETE_SUCCESS,
            MessageService.DOCUMENT_DELETE_FAILURE);
    }

    ngOnDestroy() {
        console.log('DocumentComponent ngOnDestroy called');
        // Unsubscribe from all subscriptions to prevent memory leaks and duplicate calls
        this.subscriptions.forEach(sub => {
            if (sub && !sub.closed) {
                sub.unsubscribe();
            }
        });
        this.subscriptions = [];
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/documents/document.component.ts